import React from 'react';
import { columns } from './columns';
import { Table } from 'new/elements/Table';
import { useMyDestinations } from 'new/hooks/adapters/useMyDestinations';
import DataSinkDetailActionsContainer from 'js/components/data_sinks/cards/DataSinkDetailActionsContainer';

interface DestinationsTableProps {
  orgId: number;
  shared: 'me' | 'to';
  height: number;
}

export function DestinationsTable(props: DestinationsTableProps) {
  const { orgId, height, shared } = props;
  const { sinks } = useMyDestinations();

  const rowEndRender = (row) => {
    if (!row) {
      return null;
    }
    return (
      <DataSinkDetailActionsContainer
        data={row}
        horizontalDots
        menuButtonClassName={this.props.menuButtonClassName}
        readOnly={row.readOnly}
        isManaged={row.isManaged}
      />
    );
  };

  return <Table rowEndRender={rowEndRender} height={height} columns={columns} rows={sinks} />;
}
